import {
  APP_SETTING_LOAD_DEFAULT_PAGE_BEGIN,
  APP_SETTING_LOAD_DEFAULT_PAGE_SUCCESS,
  APP_SETTING_LOAD_DEFAULT_PAGE_FAILURE,
  APP_SETTING_LOAD_DEFAULT_PAGE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function loadDefaultPage(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_LOAD_DEFAULT_PAGE_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/pages/${projectId}/default-page`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_LOAD_DEFAULT_PAGE_SUCCESS,
              data: res.data,
            });
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_LOAD_DEFAULT_PAGE_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_LOAD_DEFAULT_PAGE_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadDefaultPageError() {
  return {
    type: APP_SETTING_LOAD_DEFAULT_PAGE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_LOAD_DEFAULT_PAGE_BEGIN:
      return {
        ...state,
        loadDefaultPagePending: true,
        loadDefaultPageError: null,
      };

    case APP_SETTING_LOAD_DEFAULT_PAGE_SUCCESS:
      return {
        ...state,
        loadDefaultPagePending: false,
        loadDefaultPageError: null,
        defaultPage: action.data ? action.data : null,
      };

    case APP_SETTING_LOAD_DEFAULT_PAGE_FAILURE:
      return {
        ...state,
        loadDefaultPagePending: false,
        loadDefaultPageError: action.data.error,
      };

    case APP_SETTING_LOAD_DEFAULT_PAGE_DISMISS_ERROR:
      return {
        ...state,
        loadDefaultPageError: null,
      };

    default:
      return state;
  }
}
